<template>
    <div class="msg_container" :class="msgItem.isme ? 'me' : 'others'">
        <div class="flex_center  msg_item">
            <div class="avatar">
                <img :src="msgItem.avatar" />
            </div>

            <div>
                <div class="msg_uname">
                    <i v-if="msgItem.isme && msgItem.is_aichat == 1"
                        class="iconfont icon-zhinengkefuzhongxin m_ai_icon"></i>
                    {{ msgItem.author }}
                </div>

                <div class="msg_content_container">
                    <div v-if="msgItem.isme">
                        <div class="lds-ring" v-if="msgItem.send_status == 2">
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>
                        <div v-else-if="msgItem.send_status === 0">
                            <el-popover placement="top-start" :width="200" trigger="hover" :content="msgItem.error_msg">
                                <template #reference>
                                    <i class="iconfont icon-Shapex" style="color:red"></i>
                                </template>
                            </el-popover>
                        </div>
                    </div>

                    <div class="msg_content" @click="handlePlayAudio">
                        <div class="audio_content">
                            <div class="circle circle-dot"></div>
                            <div class="circle circle1 clip1" :class="{animate1:msgItem.id ==audioMsgId}"></div>
                            <div class="circle circle2 clip1 " :class="{animate2:msgItem.id ==audioMsgId}"></div>
                        </div>
                    </div>
                </div>

            </div>

            <!-- hello world {{ chatingPlatId }}<br />
            {{ msgItem.isme }}
            <br />
            {{ msgItem }} -->
        </div>
    </div>
</template>
<script>
// 引入动态组件（中间栏）
import { toRefs, onMounted, reactive, computed, provide, inject } from "vue";
import { useStore } from "vuex";
import { isIncludesURL } from "@/utils/securityutils";
import {
    revocationMsg
} from "@/api/chatapi";
export default {
    components: {},
    props: {
        msgItem: {
            type: Object,
            default: () => {
                return {};
            },
        },
    },
    setup(props) {
        const bus = inject("$eventBus");
        const eventbusCms = inject("eventbusCms");
        //--------------属性-------------------
        provide('msgItem', props.msgItem)
        let store = useStore();
        const data = reactive({

        });
        //当前播放的消息ID
        const audioMsgId = computed(() => {
            return store.state.profile.audioMsgId
        })
        //当前选中平台
        const chatingPlatId = computed(() => {
            return store.state.chat_store.chat_plat_id
        });
        //--------------方法-------------------
        const handlePlayAudio = async () => {
            let msg = props.msgItem?.msg
            if (!isIncludesURL(msg)) {
                return
            }
            bus.emit(eventbusCms.play_audio_msg, {id:props.msgItem?.id, audioUrl: msg })
        }

        //--------------生命周期-------------------
        onMounted(() => { });

        return {
            ...toRefs(data),
            audioMsgId,
            chatingPlatId,
            handlePlayAudio,
        };
    },
};
</script>

<style lang="scss" scoped>
.msg_container {
    display: flex;
}

.me.msg_container {
    justify-content: flex-end;
}

.others.msg_container {
    justify-content: flex-start;
}


.msg_item {
    // border: 1px solid blue;
    max-width: 535px;
    word-wrap: break-word;
    word-break: break-all;
}

.me .msg_item {
    flex-direction: row-reverse;
    align-items: flex-start;
}

.others .msg_item {
    align-items: flex-start;
}


.me .msg_uname {
    color: #aaa;
    font-size: 12px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin: -3px 10px 3px
}

.others .msg_uname {
    color: #aaa;
    font-size: 12px;
    display: flex;
    justify-content: flex-start;
    margin: -3px 10px 3px
}

.msg_content {
    position: relative;
    border-radius: 3px;
    padding: 0px 10px;
    font-size: 14px;
}


.me .msg_content {
    margin-right: 10px;
    background-color: rgba(149, 236, 105, 1);
    border-color: rgba(149, 236, 105, 1);
}

.audio_content {
    position: relative;
    height: 37px;
    width: 40px;
    cursor: pointer;
}

.me .msg_content .audio_content {

    transform: rotate(180deg);
}


.others .msg_content {
    margin-left: 10px;
    background-color: #fff;
    border-color: #fff;
}

.msg_content_container {
    display: flex;
}

.me .msg_content_container {
    display: flex;
    justify-content: flex-end;
}

.otehrs .msg_content_container {
    display: flex;
    justify-content: flex-start;
}

.me .msg_content {
    justify-content: flex-end;
}

.msg_content::after {
    content: '';
    display: inline-block;
    border-width: 5px;
    height: 0;
    width: 0;
    position: absolute;
    top: 10px;
    border-style: solid solid dashed dashed;
    border-color: transparent;
}

.me .msg_content::after {
    top: 10px;
    right: -8px;
    border-top-color: inherit;
    border-left-color: inherit;
}

.others .msg_content::after {
    top: 10px;
    left: -8px;
    border-top-color: inherit;
    border-right-color: inherit;
}



.others {
    flex-direction: row;
    align-items: flex-start;
}

.avatar {
    flex-shrink: 0;
    overflow: hidden;
    height: 35px;
    width: 35px
}

.avatar img {
    border-radius: 2px;
    vertical-align: top;
    height: 100%;
    width: 100%
}





.lds-ring {
    /* change color here */
    color: #1c4c5b;
    padding: 5px;
}

.lds-ring,
.lds-ring div {
    box-sizing: border-box;
}

.lds-ring {
    display: inline-block;
    position: relative;
    width: 20px;
    height: 20px;
}

.lds-ring div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 16px;
    height: 16px;
    margin: 2px;
    border: 2px solid currentColor;
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: currentColor transparent transparent transparent;
}

.lds-ring div:nth-child(1) {
    animation-delay: -0.45s;
}

.lds-ring div:nth-child(2) {
    animation-delay: -0.3s;
}

.lds-ring div:nth-child(3) {
    animation-delay: -0.15s;
}

@keyframes lds-ring {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}
</style>